// ไฟล์: frontend/src/components/layout/AdminSidebar.js
import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./AdminSidebar.css";

const AdminSidebar = ({ user }) => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  // ปิด Sidebar เมื่อขนาดหน้าจอเล็กและคลิกนอก Sidebar
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isOpen &&
        !event.target.closest(".admin-sidebar") &&
        !event.target.closest(".sidebar-toggle")
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isOpen]);

  // ปิด Sidebar เมื่อมีการเปลี่ยนหน้า (สำหรับหน้าจอขนาดเล็ก)
  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  // ตรวจสอบว่าลิงก์ปัจจุบันเป็น active หรือไม่
  const isActiveLink = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      <button
        className="sidebar-toggle"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle Admin Sidebar"
      >
        <i className={`fas ${isOpen ? "fa-times" : "fa-bars"}`}></i>
      </button>

      <aside className={`admin-sidebar ${isOpen ? "active" : ""}`}>
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <img
              src={
                process.env.REACT_APP_LOGO_URL ||
                "https://www.i-pic.info/i/krVq1004512.jpg"
              }
              alt="Logo"
            />
          </div>
          <div className="sidebar-title">
            <h2>แผงควบคุม</h2>
            <p>ผู้ดูแลระบบ</p>
          </div>
        </div>

        <div className="sidebar-user">
          <div className="user-avatar">
            <img
              src={
                user.profile_image
                  ? `${process.env.REACT_APP_API_URL}/uploads/profiles/${user.profile_image}`
                  : `https://ui-avatars.com/api/?name=${user.fullname}&background=random`
              }
              alt={user.fullname}
            />
          </div>
          <div className="user-info">
            <h3>{user.fullname}</h3>
            <p>{user.role === "admin" ? "ผู้ดูแลระบบ" : "ครูผู้สอน"}</p>
          </div>
        </div>

        <nav className="sidebar-nav">
          <ul>
            <li>
              <Link
                to="/admin/dashboard"
                className={isActiveLink("/admin/dashboard") ? "active" : ""}
              >
                <i className="fas fa-tachometer-alt"></i>
                <span>แดชบอร์ด</span>
              </Link>
            </li>
            <li>
              <Link
                to="/admin/users"
                className={isActiveLink("/admin/users") ? "active" : ""}
              >
                <i className="fas fa-users"></i>
                <span>จัดการผู้ใช้งาน</span>
              </Link>
            </li>
            <li>
              <Link
                to="/admin/resources"
                className={isActiveLink("/admin/resources") ? "active" : ""}
              >
                <i className="fas fa-book"></i>
                <span>จัดการสื่อการสอน</span>
              </Link>
            </li>

            <li>
              <Link
                to="/admin/articles"
                className={
                  location.pathname === "/admin/articles" ? "active" : ""
                }
              >
                <i className="fas fa-pen-fancy"></i> จัดการบทความและแนวคิด
              </Link>
            </li>

            {/* เพิ่มเมนูจัดการนวัตกรรม */}
            <li>
              <Link
                to="/admin/innovations"
                className={isActiveLink("/admin/innovations") ? "active" : ""}
              >
                <i className="fas fa-lightbulb"></i>
                <span>จัดการนวัตกรรม</span>
              </Link>
            </li>
            <li>
              <Link
                to="/admin/categories"
                className={isActiveLink("/admin/categories") ? "active" : ""}
              >
                <i className="fas fa-folder"></i>
                <span>จัดการหมวดหมู่</span>
              </Link>
            </li>
            <li>
              <Link
                to="/admin/subjects"
                className={isActiveLink("/admin/subjects") ? "active" : ""}
              >
                <i className="fas fa-graduation-cap"></i>
                <span>จัดการวิชา</span>
              </Link>
            </li>
            <li>
              <Link
                to="/admin/grade-levels"
                className={isActiveLink("/admin/grade-levels") ? "active" : ""}
              >
                <i className="fas fa-layer-group"></i>
                <span>จัดการระดับชั้น</span>
              </Link>
            </li>
            <li>
              <Link
                to="/admin/create-news"
                className={isActiveLink("/admin/create-news") ? "active" : ""}
              >
                <i className="fas fa-newspaper"></i>
                <span>เพิ่มข่าวสาร</span>
              </Link>
            </li>
            <li className="sidebar-divider"></li>
            <li>
              <Link to="/dashboard">
                <i className="fas fa-user-circle"></i>
                <span>โหมดผู้ใช้</span>
              </Link>
            </li>
            <li>
              <Link to="/">
                <i className="fas fa-home"></i>
                <span>หน้าหลัก</span>
              </Link>
            </li>
          </ul>
        </nav>

        <div className="sidebar-footer">
          <p>TeacherShare v1.0.0</p>
        </div>
      </aside>
    </>
  );
};

export default AdminSidebar;
